import React, {useEffect} from 'react';

//Hooks
import {useSelector, useDispatch} from "react-redux";

//Actions
import * as actions from "../../store/actions";

//Components
import { Switch, Route } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import Navigator from '../../components/Navigator/Navigator';

//Routes
import Layout from "../../components/Layout/Layout";
import Header from "../../components/Header/Header";
import Shops from "../booking/Shops/Shops";
import Shop from "../booking/shop/Shop/Shop";
import Book from '../booking/book/Book/Book';
import Event from "../booking/Event/Event";
import Bundle from '../booking/Bundle/Bundle';
import Profile from "../profile/Profile/Profile";
import Notifications from "../notifications/Notifications/Notifications";
import Reservations from "../reservations/Reservations/Reservations";
import SignInScreen from "../signin/SignInScreen";
import SubscriptionDetail from '../subscriptions/Details';
import NotFound from '../NotFound/NotFound';

import { useIntegrationLibrary } from '../../hooks/useIntegrationLibrary';

import { ROUTER_PATH } from '../../const/ROUTER_PATH';

const Index = ({baseURL, wsBaseURL, companyAPIKey, strictPath = false, showCloseButton = true, style, user, password}) => {
    const isSignedIn = useSelector(state => state.auth.isSignup);
    const selectedCompany = useSelector(state => state.companies.selectedCompany);
    const email = useSelector(state => state.profile.profile ? state.profile.profile.email : null);
    const dispatch = useDispatch();

    useIntegrationLibrary();

    useEffect(() => {
        dispatch(actions.loadWidgetSettings(baseURL, wsBaseURL, companyAPIKey, strictPath, showCloseButton, style, user, password));
        dispatch(actions.restoreSession());
        dispatch(actions.connectToWebSocket());
    }, [baseURL, wsBaseURL, companyAPIKey, strictPath, showCloseButton, style, user, password, dispatch]);

    useEffect(() => {
        if (!isSignedIn) {
            return;
        }

        dispatch(actions.getProfile());
    }, [isSignedIn, dispatch]);

    useEffect(() => {
        dispatch(actions.authenticate());
    }, [email, companyAPIKey, dispatch]);

    if(!selectedCompany) {
        return (
            <div style={{
                height: '100%',
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Loader
                    type="TailSpin"
                    color="#000"
                    height={48}
                    width={48}
                />
            </div>
        )
    }

    return (
        <Layout>
            <Header/>
            <Switch>
                <Route
                    path={ROUTER_PATH.SHOPS}
                    exact
                    component={Shops}
                />
                <Route
                    path={ROUTER_PATH.SHOPS_ID_BUNDLES_ID}
                    component={Bundle}
                />
                <Route
                    path={ROUTER_PATH.SHOPS_ID_EVENTS_ID}
                    component={Event}
                />
                <Route
                    path={ROUTER_PATH.SHOPS_ID}
                    component={Shop}
                />
                <Route
                    path={ROUTER_PATH.BOOK}
                    component={Book}
                />
                <Route
                    path={ROUTER_PATH.PROFILE}
                    component={Profile}
                />
                <Route
                    path={ROUTER_PATH.RESERVATIONS}
                    component={Reservations}
                />
                <Route
                    path={ROUTER_PATH.NOTIFICATIONS}
                    component={Notifications}
                />
                <Route
                    path={ROUTER_PATH.SIGN_IN_ROUTE}
                    component={SignInScreen}
                />
                <Route
                    path={ROUTER_PATH.SUBSCRIPTION_DETAILS}
                    component={SubscriptionDetail}
                />
                <Route
                    path="*"
                    exact
                    component={NotFound}
                />
            </Switch>
            <Navigator />
        </Layout>
    )
};

export default Index
